import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { COUNTRY_CODE } from '../models/country-config/countries';
import { ICountryConfig } from '../models/country-config/country-config.interface';
import { HttpCemex } from '../../angular-services-v8/http.service';

// INTERFACES

@Injectable()
export class CountryConfigService {
  constructor(private http: HttpCemex) {}

  getCountryConfig(countryCode: COUNTRY_CODE): Observable<ICountryConfig> {
    return this.http.get<ICountryConfig>(`/v5/secm/console/countryconfig?countryCode=${countryCode}`);
  }
}
